import React, {Component} from 'react';
import PropTypes from 'prop-types';

class CheckboxWithOnly extends Component {
  static defaultProps = {
    price: '',
    translations: null
  };

  state = {
    mouseIsHover: false
  };

  onMouseEnter = () => {
    this.setState({mouseIsHover: true});
  };

  onMouseLeave = () => {
    this.setState({mouseIsHover: false});
  };

  onClick = (e) => {
    e.preventDefault();
    const {onClickOnly, value} = this.props;
    onClickOnly(value);
  };

  render() {
    const {value, isChecked, label, price, translations, onChange, onClickOnly} = this.props;
    const {mouseIsHover} = this.state;

    return (
      <div
        className="custom-checkbox"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <div className="text-small float-right">
          {
            (mouseIsHover && onClickOnly) &&
              <a className="airline-only" onClick={this.onClick}>{translations.only}</a>
          }
          {
            (translations && price) &&
              <span className="text-muted">&nbsp;{translations.from}&nbsp;{price}</span>
          }
        </div>
        <label className="d-block text-truncate">
          <div className="d-inline-block mr-1">
            <input
              className="custom-checkbox-input"
              type="checkbox"
              name="airline-filter"
              value={value}
              checked={isChecked}
              onChange={onChange}
            />
            <span className="custom-checkbox-label"></span>
          </div>
          {label}
        </label>
      </div>
    );
  }
}

CheckboxWithOnly.propTypes = {
  value: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.string,
  isHoverable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClickOnly: PropTypes.func,
  translations: PropTypes.shape({
    from: PropTypes.string,
    only: PropTypes.string
  })
};

export default CheckboxWithOnly;
